<div class="chat-modal-overlay" role="presentation" *ngIf="modals.length > 0">
  <div class="chat-modal-stack">
    <div
      class="chat-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Alerta de inatividade"
      *ngFor="let modal of modals; trackBy: trackByModalId"
    >
      <p class="chat-modal-message">{{ modal.message }}</p>

      <div class="chat-modal-actions" *ngIf="modal.buttons.length > 0">
        <button
          type="button"
          class="chat-modal-action-button"
          *ngFor="let button of modal.buttons"
          (click)="onButtonClick(modal.id, button.id)"
        >
          {{ button.label }}
        </button>
      </div>
    </div>
  </div>
</div>
